import { FetchFromBackoffice } from '../utils/requests';
import { SaveToBackoffice } from '../utils/requests';

export type InspectionStep = {
  area: string;
  section: string;
  description: string;
};

export type InspectionProcess = {
  process: string;
  steps: InspectionStep[];
};

export const fetchInspections = (organisationId: string) =>
  FetchFromBackoffice<InspectionProcess[]>(`portal/inspections/steps/${organisationId}`);

export const updateInspectionProcess = (
  organisationId: string,
  process: string,
  steps: InspectionStep[]
) => SaveToBackoffice(
  `portal/inspections/steps/${organisationId}/${encodeURIComponent(process)}`,
  { steps }
);